export default "__VITE_PUBLIC_ASSET__e7cef80d__"